import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService } from 'src/app/core/services/templates.service';
import { PendingDocument } from 'src/app/shared/models/pending-document.model';
import * as TiposFacturaEnum from '../../../../shared/enums/tiposFactura.enum';
import { InvoiceService } from '../../../../core/services/invoice.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html'
})
export class TemplateListComponent implements OnInit {

  //Filtro...
  tiposFactura: TiposFacturaEnum.TiposFacturaPLANTILLAS[];
  formulario: FormGroup;
  formularioCompletado: boolean = false;

  //Carga de resultados...
  loading: boolean = false;
  loadingCarga: boolean = false;
  loadingSave: boolean = false;
  mostrarError: boolean = false;
  mostrarErrorSave: boolean = false;
  mostrarIdRecognizer: boolean;
  cargandoResultados: boolean = false;
  nifListadoRECIBIDAS: string = "";
  secundarioListadoEMITIDAS: string = "";
  avisoNoHay10: boolean = false;
  tipoFacturaTexto: string = '';
  tipoFacturaBUSQUEDA: number = 0;
  nifBUSQUEDA: string = '';
  secundarioBUSQUEDA: string = '';
  totalSeleccionados: number = 0;
  datos: PendingDocument[] = [];
  esUsuarioTercero: boolean = false;
  principalTercero: string = '';
  existeConfigPlantilla: boolean = false;

  //Si venimos desde invoicer a traés de botón crear plantilla...
  valorTipoBusqueda: number = 0;
  valorCadena: string = "";

  constructor(
    private fb: FormBuilder,
    private templatesService: TemplatesService,
    private invoiceServices: InvoiceService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
  ) {

    this.tiposFactura = TiposFacturaEnum.TiposDeFacturaPLANTILLAEnum;
    this.tipoFacturaTexto = "";

    this.formulario = this.fb.group({
      tipoDeFactura: [0],
      recibidaNIF: [''],
      emitidaSECUNDARIO: [''],
      checkTerceros: [false],
      terceroPrincipal: ['']
    });

    console.log(this.activatedRouter);
    this.activatedRouter.paramMap.subscribe(parametros => {

      this.valorTipoBusqueda = Number(parametros.get('tipo'));
      this.valorCadena = parametros.get('nifSecundario');
      console.warn(this.valorTipoBusqueda);
      console.warn(this.valorCadena);

      if (this.valorTipoBusqueda && this.valorTipoBusqueda != 0) {

        this.formulario.patchValue({
          tipoDeFactura: this.valorTipoBusqueda,
          emitidaSECUNDARIO: (this.valorTipoBusqueda == 1) ? this.valorCadena : '',
          recibidaNIF: (this.valorTipoBusqueda == 2) ? this.valorCadena : '',
          checkTerceros: false,
          terceroPrincipal: ''
        });

        //lanzamos carga...
        this.onSubmit(this.formulario);
      }

    }, error => {
      this.toastr.error("Error cargando parámetros de plantilla");
      console.log(error);
    });
  }

  ngOnInit() {
  }

  changeSelect() {
    this.formularioCompletado = false;

    this.formulario.patchValue({
      recibidaNIF: '',
      emitidaSECUNDARIO: '',
      checkTerceros: false,
      terceroPrincipal: ''
    });
  }

  onSubmit(f: FormGroup) {
    this.formularioCompletado = false;
    this.cargandoResultados = true;

    console.log("Mostrando datos del formulario: ");
    console.log(f);

    if (this.formulario.get('tipoDeFactura').value == 2) {

      //recibida
      this.formulario.patchValue({
        emitidaSECUNDARIO: '',
        checkTerceros: false,
        terceroPrincipal: ''
      });

      this.nifListadoRECIBIDAS = this.formulario.get('recibidaNIF').value

      this.tipoFacturaTexto = "R";
      this.tipoFacturaBUSQUEDA = 2;
      this.nifBUSQUEDA = this.formulario.get('recibidaNIF').value;

      //Carga datos...
      this.CargarListadoDocumentos();
      this.cargandoResultados = false;
      this.formularioCompletado = true;

    } else {

      //emitida
      this.formulario.patchValue({
        recibidaNIF: ''
      });

      this.secundarioListadoEMITIDAS = this.formulario.get('emitidaSECUNDARIO').value;
      this.tipoFacturaTexto = "";
      this.tipoFacturaBUSQUEDA = 1;
      this.secundarioBUSQUEDA = this.formulario.get('emitidaSECUNDARIO').value;
      this.esUsuarioTercero = this.formulario.get('checkTerceros').value;

      //PARA TERCEROS...
      if (this.esUsuarioTercero == true) {

        this.principalTercero = this.formulario.get('terceroPrincipal').value;
        this.nifBUSQUEDA = '';
        //SACAR NIF DE LA FACTURA DE TERCERO (?????????????)

      } else {

        this.principalTercero = '';
        this.invoiceServices.obtenerNifSecundario(this.secundarioBUSQUEDA)
          .subscribe((resp: string) => {

            if (resp == "") {
              this.toastr.error("No se ha encontrado ningún NIF/CIF asociado al secundario indicado");
              this.nifBUSQUEDA = '';
              this.datos = [];
              this.cargandoResultados = false;
              this.formularioCompletado = true;
              return;
            }

            this.nifBUSQUEDA = resp;

            //Carga datos...
            this.CargarListadoDocumentos();

            this.cargandoResultados = false;
            this.formularioCompletado = true;

          }, (error) => {
            console.log(error);
            this.toastr.error("Error al buscar en NIF del secundario para factura EMITIDA");
            this.nifBUSQUEDA = '';
            this.datos = [];
            this.cargandoResultados = false;
            this.formularioCompletado = true;
          });
      }
    }
  }

  CargarListadoDocumentos() {


    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {
        //Se cierra sesion...

        const userId: string = this.authService.currentUserValue.email;

        this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
          this.authService.Logout();
          this.toastr.info("El Invoicer esta en mantenimiento. Espere un momento a que vuelva a estar habilitado.");
          this.router.navigate(['/Login']);
        }, error => {
          console.log(error);
        });

      } else {

        this.loading = true;
        this.mostrarError = false;
        this.datos = [];
        this.existeConfigPlantilla = false;
        this.avisoNoHay10 = false;

        console.log("tipoFactura", this.tipoFacturaBUSQUEDA);
        console.log("nif", this.nifBUSQUEDA);
        console.log("secundario", this.secundarioBUSQUEDA);
        console.log("EsTercero", this.esUsuarioTercero);
        console.log("Principal tercero", this.principalTercero);

        if (this.tipoFacturaBUSQUEDA == 1 && this.nifBUSQUEDA == "") {
          this.toastr.error("No se ha encontrado ningún NIF/CIF asociado al secundario indicado")
        }

        //Comprobamos si ya existe una configuración registrada de la plantilla...
        this.templatesService.ComprobarExistePlantillaConfig(this.tipoFacturaBUSQUEDA, this.nifBUSQUEDA)
          .subscribe(resultado => {

            if (resultado == false) {

              this.existeConfigPlantilla = false;

              this.templatesService.ObtenerListadoDocumentosParaProcesar(this.tipoFacturaBUSQUEDA, this.secundarioBUSQUEDA, this.nifBUSQUEDA, this.esUsuarioTercero, this.principalTercero)
                .subscribe(datos => {

                  this.loading = false;
                  this.datos = datos;
                  console.warn("INFO PLANTILLAS SACADAS: ");
                  console.warn(this.datos);

                  if (this.datos.length < 10) {
                    this.avisoNoHay10 = true;
                  }

                  //////////////////////////////////////////////////////////////////////////
                  //Ya obtenemos el numero de páginas de la tabla Documentos (NomberOfPages)
                  this.datos.forEach(element => {

                    if (element.numeroPaginas == 0 || element.numeroPaginas == null) {
                      this.invoiceServices.ObtenerNumeroPaginas(element.idDoc).subscribe(paginas => element.numeroPaginas = paginas);
                    }
                  });

                }, (error) => {
                  console.log(error);
                  this.loading = false;
                  this.mostrarError = true;
                });
            } else {

              this.existeConfigPlantilla = true;
              this.loading = false;
            }
          }, error => {
            this.loading = false;
            this.toastr.error("Error comprobando la existencia de configuración de plantilla");
            console.log(error);
          });
      }

    }, error => {
      console.log(error);
    });
  }

  SeleccionarDocumento(idDoc: number) {

    this.totalSeleccionados = 0;

    this.datos.forEach(element => {
      if (element.idDoc == idDoc) {
        element.nifConPlantilla = !element.nifConPlantilla;
      }
      if (element.nifConPlantilla == true) {
        this.totalSeleccionados = this.totalSeleccionados + 1;
      }
    });
  }

  EnviarAespacioEntrenamiento() {
    this.loadingCarga = true;
    this.mostrarError = false;
    this.mostrarIdRecognizer = false;

    const botonMostrarModalCarga = document.getElementById("botonIdsubida") as HTMLElement;
    botonMostrarModalCarga.click();

    let elementosEnviar: number[] = [];

    this.datos.forEach(element => {
      if (element.nifConPlantilla == true) {
        elementosEnviar.push(element.idDoc);
      }
    });

    let nombreCarpeta = `${this.tipoFacturaTexto}${this.nifBUSQUEDA}`;

    console.log("tipoFactura", this.tipoFacturaBUSQUEDA);
    console.log("nif", this.nifBUSQUEDA);
    console.log("secundario", this.secundarioBUSQUEDA);
    console.log("EsTercero", this.esUsuarioTercero);
    console.log("Principal tercero", this.principalTercero);

    if (this.tipoFacturaBUSQUEDA == 1 && this.nifBUSQUEDA == "") {
      this.toastr.error("No se ha encontrado ningún NIF/CIF asociado al secundario indicado")
    }

    //COMPROBAMOS EXISTENCIA DE CONFIGURACIÓN DE PLANTILLA...
    this.templatesService.ComprobarExistePlantillaConfig(this.tipoFacturaBUSQUEDA, this.nifBUSQUEDA)
      .subscribe(existe => {

        if (existe == false) {

          this.templatesService.EnviarEspacioEntrenamiento(nombreCarpeta, elementosEnviar).subscribe(resultado => {

            this.loadingCarga = false;

            if (resultado == false) {
              this.mostrarError = true;
              return;
            }

            if (resultado == true) {
              this.mostrarIdRecognizer = true;
            }

          }, (error) => {
            console.log(error);
            this.loadingCarga = false;
            this.mostrarError = true;
          });

        } else {

          this.loadingCarga = false;
          this.toastr.error("Ya existe una configuración de plantillas para este CIF/NIF");
        }

      }, error => {
        console.log(error);
        this.loadingCarga = false;
        this.mostrarError = true;
      });
  }

  FinalizarGrabacionTemplate() {
    this.loadingSave = true;
    this.mostrarErrorSave = false;

    let nombreCarpeta = `${this.tipoFacturaTexto}${this.nifBUSQUEDA}`;

    console.log("tipoFactura", this.tipoFacturaBUSQUEDA);
    console.log("nif", this.nifBUSQUEDA);
    console.log("secundario", this.secundarioBUSQUEDA);
    console.log("EsTercero", this.esUsuarioTercero);
    console.log("Principal tercero", this.principalTercero);


    if (this.tipoFacturaBUSQUEDA == 1 && this.nifBUSQUEDA == "") {
      this.toastr.error("No se ha encontrado ningún NIF/CIF asociado al secundario indicado")
    }

    //COMPROBAMOS EXISTENCIA DE CONFIGURACIÓN DE PLANTILLA...
    this.templatesService.ComprobarExistePlantillaConfig(this.tipoFacturaBUSQUEDA, this.nifBUSQUEDA)
      .subscribe(existe => {

        if (existe == false) {

          this.templatesService.GrabarIdTemplate(nombreCarpeta).subscribe((resultado: boolean) => {

            if (resultado == false) {
              this.loadingSave = false;
              this.mostrarErrorSave = true;
            }

            this.templatesService.ReconocerDocumentosPendientes(nombreCarpeta).subscribe((resultado2: boolean) => {
              this.loadingSave = false;

              if (resultado2 == false) {
                this.mostrarErrorSave = true;
                return;
              }

              this.CerrarModalCargaDocumentos();
              this.router.navigate(['/Templates']);
            }, (error) => {
              console.log(error);
              this.loadingSave = false;
              this.mostrarErrorSave = true;
            });
          }, (error) => {
            console.log(error);
            this.loadingSave = false;
            this.mostrarErrorSave = true;
          });
        } else {
          this.loadingSave = false;
          this.toastr.error("Ya existe una configuración de plantillas para este CIF/NIF");
        }

      }, error => {
        console.log(error);
        this.loadingSave = false;
        this.mostrarErrorSave = true;
        this.toastr.error("Ya existe una configuración de plantillas para este CIF/NIF");
      });
  }

  CerrarModalCargaDocumentos() {

    const botonCERRADOaviso = document.getElementById("cerrarAvisoSUBIDA") as HTMLElement;
    botonCERRADOaviso.click();
  }




}
